import { render } from "./Planos.vue?vue&type=template&id=04f5de71&scoped=true"
import script from "./Planos.vue?vue&type=script&lang=js"
export * from "./Planos.vue?vue&type=script&lang=js"

import "./Planos.vue?vue&type=style&index=0&id=04f5de71&scoped=true&lang=css"

import exportComponent from "I:\\Centrion\\projetos\\aut_fri_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04f5de71"]])

export default __exports__